import * as React from 'react'
import {ActionType, CHAINTYPES, reducerStoreType, storeType, userType, ROLES} from "../../reducers/types";
import './UserList.scss'
import AlertDialog from "../../components/CustomUIComp/AlertDialog";
import {connect} from "react-redux";
import {Dispatch} from "redux";
import CustomDialog from "../../components/CustomUIComp/CustomDialog";
import ModifyUserModal from "./ModifyUserModal";
import {changeUserReq} from "../../api/types";
import TableHead from "@material-ui/core/TableHead";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import IconButton from "@material-ui/core/IconButton";
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import {StyledTableCell} from "../../components/CustomUIComp/CustomTable";
import noDataIcon from '../../images/null_icon.svg';
import {injectIntl, IntlShape} from 'react-intl'

interface IProps {
    list: userType[],
    storeList: storeType[],
    chainType: CHAINTYPES,
    dispatch: Dispatch<ActionType<any>>,
    role: ROLES,
    intl: IntlShape,
    cashierNo: string
}

interface IState {
    alertOpen: boolean,
    deletingId: number,
    modifyOpen: boolean,
    userForm: changeUserReq,
    userFormErrors: { [key: string]: string },
    anchorEl: null | HTMLElement,
    openMenu: number
}

const defaultUserForm = {
    id: 0,
    loginNo: '',
    phoneNo: '',
    name: '',
    role: ROLES.NONE,
    storeId: -1,
    userEmail: ''
}

class UserList extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props)
        this.state = {
            alertOpen: false,
            deletingId: 0,
            modifyOpen: false,
            userForm: defaultUserForm,
            userFormErrors: {},
            anchorEl: null,
            openMenu: -1
        }
    }

    onDelete = (id: number) => {
        this.handleMoreClose()
        this.openAlert(id)
    }
    closeAlert = () => {
        this.setState({
            alertOpen: false,
            deletingId: 0
        })
    }
    openAlert = (id: number) => {
        this.setState({
            alertOpen: true,
            deletingId: id
        })
    }
    onConfirm = () => {
        this.props.dispatch({type: 'USER_CHANGE', payload: {data: {id: this.state.deletingId}, changeType: 'delete'}})
        this.closeAlert()
    }
    handleUserFormChange = (object: { name: string, value: any }) => {
        let {userForm} = this.state
        let newState = {
            ...this.state,
            userForm: {
                ...userForm,
                [object.name]: object.value
            }
        }
        this.setState(newState)
    }
    validateUserForm = () => {
        let errors: { [key: string]: string } = {}
        let {loginNo, name, phoneNo} = this.state.userForm
        // let emailPattern = /^([A-Za-z0-9_\-.\u4e00-\u9fa5])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,8})$/;

        // 邮箱
        if (!loginNo) {
            errors['loginNo'] = '邮箱不能为空'
        }
        // else if (!emailPattern.test(loginNo)) {
        //     errors['loginNo'] = '邮箱格式不正确'
        // }
        // 姓名
        if (!name) {
            errors['name'] = '姓名不能为空'
        }
        // 手机号码
        if (!/^(\d|-)*$/.test(phoneNo || '')) {
            errors['phoneNo'] = '手机号格式不正确'
        }

        this.setState({
            userFormErrors: errors
        })

        if (Object.keys(errors).length > 0) {
            return false
        } else {
            return true
        }

    }

    changeUserConfirm = () => {
        if (!this.validateUserForm()) {
            return;
        }
        this.closeDialog()
        this.props.dispatch({type: 'USER_CHANGE', payload: {data: this.state.userForm, changeType: 'change'}})
    }
    closeDialog = () => {
        this.setState({
            modifyOpen: false,
            userForm: defaultUserForm
        })
    }
    onModify = (userItem: userType) => {
        console.log('on modify', userItem)
        this.handleMoreClose()
        let {job, loginTime, email, ...others} = userItem
        let newUserForm = {
            ...this.state.userForm,
            ...others
        }
        this.setState({
            modifyOpen: true,
            userForm: newUserForm
        })
    }
    renderCashier = (name: string) => {
        let short = name.substr(0, 1)
        return (<span className='cashierTextAvatar' title={name}>{short.toUpperCase()}</span>)
    }
    _findStoreById = (id: number): string => {
        for (var i in this.props.storeList) {
            if (this.props.storeList[i].storeId === id) {
                return this.props.storeList[i].storeName
            }
        }
        return ''
    }
    handleMoreClick = (event: React.MouseEvent<HTMLElement>, index: number) => {
        this.setState({
            anchorEl: event.currentTarget,
            openMenu: index
        })
    }
    handleMoreClose = () => {
        this.setState({
            anchorEl: null,
            openMenu: -1
        })
    }

    public render() {
        let {list, intl} = this.props

        return (
            <div className="usersList">
                <div className="list">
                    <Table>
                        <TableHead>
                            <TableRow>
                                <StyledTableCell>{intl.formatMessage({id: 'name'})}/{intl.formatMessage({id: 'loginNo'})}</StyledTableCell>
                                <StyledTableCell
                                    align='center'>{intl.formatMessage({id: 'phoneNumber'})}</StyledTableCell>
                                <StyledTableCell align='center'>{intl.formatMessage({id: 'role'})}</StyledTableCell>
                                <StyledTableCell
                                    align='center'>{intl.formatMessage({id: 'storeName'})}</StyledTableCell>
                                <StyledTableCell
                                    align='center'>{intl.formatMessage({id: 'lastLogin'})}</StyledTableCell>
                                <StyledTableCell
                                    align='center'>{intl.formatMessage({id: 'operations'})}</StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {list.map((item, i) => {
                                return (<TableRow key={item.cashierNo} hover>
                                    <StyledTableCell>
                                        <div className="infoGroup">
                                            {this.renderCashier(item.name || item.loginNo)}
                                            <div className="info">
                                                <span>{item.name}</span>
                                                <p>{item.loginNo}</p>
                                            </div>
                                        </div>
                                    </StyledTableCell>
                                    <StyledTableCell align='center'>
                                        {item.phoneNo || '-'}
                                    </StyledTableCell>
                                    <StyledTableCell align='center'>
                                        {intl.formatMessage({id: ROLES[item.role]})}
                                    </StyledTableCell>
                                    <StyledTableCell align='center'>
                                        {this._findStoreById(item.storeId) || '-'}
                                    </StyledTableCell>
                                    <StyledTableCell align='center'>
                                        {item.loginTime || '-'}
                                    </StyledTableCell>
                                    <StyledTableCell align='center'>
                                        <IconButton
                                            aria-label="more"
                                            aria-controls={`user-menu-${item.id}`}
                                            aria-haspopup="true"
                                            onClick={(event: React.MouseEvent<HTMLElement>) => this.handleMoreClick(event, i)}
                                        >
                                            <MoreHorizIcon/>
                                        </IconButton>
                                        <Menu
                                            id={`user-menu-${item.id}`}
                                            anchorEl={this.state.anchorEl}
                                            keepMounted
                                            open={i === this.state.openMenu}
                                            onClose={this.handleMoreClose}
                                        >
                                            <MenuItem onClick={this.onModify.bind(this, item)}>
                                                {intl.formatMessage({id: 'modify'})}
                                            </MenuItem>
                                            {this.props.cashierNo === item.cashierNo ? null :
                                                <MenuItem onClick={() => this.onDelete(item.id)}>
                                                    {intl.formatMessage({id: 'delete'})}
                                                </MenuItem>
                                            }
                                        </Menu>
                                    </StyledTableCell>
                                </TableRow>)
                            })}
                        </TableBody>
                    </Table>
                    {list.length === 0 ?
                        <div className="noData">
                            <img src={noDataIcon} alt="no data"/>
                            <p>{intl.formatMessage({id: 'noData'})}</p>
                        </div>
                        : null}
                </div>
                <AlertDialog open={this.state.alertOpen}
                             title={intl.formatMessage({id: 'deleteUser'})}
                             content={intl.formatMessage({id: 'confirmDeleteMsg'})}
                             handleClose={this.closeAlert}
                             onConfirm={this.onConfirm}/>
                <CustomDialog open={this.state.modifyOpen}
                              title={intl.formatMessage({id: 'modifyUser'})}
                              content={<ModifyUserModal role={this.props.role}
                                                        errors={this.state.userFormErrors}
                                                        handleChange={this.handleUserFormChange}
                                                        formData={this.state.userForm}
                                                        chainType={this.props.chainType}
                                                        storeList={this.props.storeList}/>}
                              onConfirm={this.changeUserConfirm}
                              handleClose={this.closeDialog}/>
            </div>
        );
    }
}

export default injectIntl(connect((state: reducerStoreType) => {
    return {
        role: state.app.userInfo ? state.app.userInfo.role : ROLES.NONE,
        cashierNo: state.app.userInfo ? state.app.userInfo.cashierNo : ''
    }
})(UserList))
